export default __webpack_public_path__ + "static/media/equinix-dashboard.073ebaba.png";